






















import { Vue, Component } from 'vue-property-decorator'

@Component({
  components: {},
})
export default class Home extends Vue {
  private content = ''
  private isSubmitting = false
  private statusMessage: string | null = null

  get submitOk() {
    return !this.isSubmitting
  }

  get contentLength() {
    return this.content.length
  }

  async postWebhook() {
    if (!this.submitOk) return

    const data = {
      content: this.content,
    }
    const url = `https://discordapp.com/api/webhooks/${process.env.VUE_APP_WEBHOOK_ID}/${process.env.VUE_APP_WEBHOOK_TOKEN}`

    await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
      body: JSON.stringify(data),
    })
      .then((res) => {
        this.statusMessage = 'success'
      })
      .catch((err) => {
        window.alert(err)
        this.statusMessage = 'error'
      })
      .finally(() => {
        this.isSubmitting = false
      })
  }
}
